import { Component, Inject, OnInit, OnDestroy, Injectable } from '@angular/core';
import {
    DwAction, DwActionType, DwButtonType, DwActionHandler, DwMdFormActionState,
    DwActionResult, DwConfigServiceToken, DwConfigService,
    DwRoutingService,
    DwMetaDataGridActionState,
    DwGridActionResult,
    DwEventService,
    DwOrmDataService,
    DwMessageSeverity
} from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../meta-data/app-meta-data.service';
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map, mergeMap } from 'rxjs/operators';
import { PaymentParty } from '../models/payment-party.enum';
import { PaymentsRepositoryService } from '../services/payments-repository.service';

@DwAction({
    keyName: 'remove-payment-method-grid',
    display: 'Remove Payment Method',
    actionType: DwActionType.gridRowAction,
    isGlobal: false,
    parentItemName: [AppMetaDataItemNames.RoSchoolPaymentMethod, AppMetaDataItemNames.RoStudentPaymentMethod],
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Remove Card',
        buttonType: DwButtonType.iconOnlyNoText,
        buttonClass: 'btn btn-primary',
        iconClass: 'dw-icon-delete-grid',
    },
    defaultConfirmConfig: {
        showConfirmDialog: true,
        showDialogConfig: true,
        title: 'Remove Card',
        message: 'Are you sure you want to remove this card?',
    }
})
@Injectable()
export class RemovePaymentMethodActionService implements DwActionHandler {
    paymentsApi: string;
    constructor(
        private paymentRepository: PaymentsRepositoryService,
        private dwRoutingService: DwRoutingService,
        private dwEventService: DwEventService,
        @Inject(DwConfigServiceToken) private configService: DwConfigService) {
        this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
    }

    handleAction(actionState: DwMetaDataGridActionState): Observable<DwGridActionResult> {
        const isSchoolSettingsPage = this.dwRoutingService.currentPageUrl.indexOf('/setting') >= 0;

        const paymentParty = isSchoolSettingsPage ? PaymentParty.FlightSchool : PaymentParty.Student;

        const paymentMethodId = actionState.data?.PaymentMethodId;

        return this.paymentRepository.removePaymentMethod(paymentMethodId, paymentParty)
            .pipe(map(apiActionResult => {
                const result: DwGridActionResult = {
                    success: apiActionResult.Success
                };

                if (!apiActionResult.Success) {
                    result.message = {
                        messageBody: apiActionResult.Message,
                        severity: DwMessageSeverity.error,
                        allowClose: true,
                        timeToShow: 5000
                    }

                    // refresh just in case it did mark the card as inactive, but ran into another error
                    result.refreshData = true;
                }

                if (apiActionResult.Success) {
                    result.refreshData = true;

                    // Publish all methods related to payment method changes
                   this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.PaymentMethod), {});
                   this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.RoSchoolPaymentMethod), {});
                   this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.RoStudentPaymentMethod), {});
                }

                return result;
            }));
    }
}